<template>
  <svg viewBox="0 0 1199 1722" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M729 928V810h83v-86h-83V379H620L374 694v116h250v118h105zM461 724v-2l161-209h2v211H461zm138-600c292 0 528 236 528 528 0 291-236 528-528 528-291 0-528-237-528-528 0-292 237-528 528-528z" />
  </svg>
</template>
